interface DistributionChartData {
    label: string;
    value: number;
    color: string;
}

interface DistributionChartProps {
    title: string;
    data: DistributionChartData[];
    total: number;
    onItemClick?: (item: DistributionChartData) => void;
}

export function DistributionChart({ title, data, total, onItemClick }: DistributionChartProps) {
    return (
        <div className="rounded-xl bg-primary p-6 shadow-xs ring-1 ring-secondary">
            <h3 className="text-lg font-semibold text-primary mb-4">{title}</h3>
            <div className="space-y-4">
                {data.map((item) => {
                    const percentage = total > 0 ? (item.value / total) * 100 : 0;
                    const isClickable = !!onItemClick;
                    
                    return (
                        <div 
                            key={item.label} 
                            className={`space-y-2 ${isClickable ? 'cursor-pointer hover:bg-secondary/50 rounded-lg p-2 -m-2 transition-colors' : ''}`}
                            onClick={isClickable ? () => onItemClick(item) : undefined}
                        >
                            <div className="flex items-center justify-between">
                                <span className={`text-sm font-medium text-primary ${isClickable ? 'hover:text-brand-600' : ''}`}>
                                    {item.label}
                                </span>
                                <div className="flex items-center gap-2">
                                    <span className="text-sm text-tertiary">{item.value}</span>
                                    <span className="text-sm font-medium text-primary w-12 text-right">
                                        {percentage.toFixed(0)}%
                                    </span>
                                </div>
                            </div>
                            <div className="w-full bg-secondary rounded-full h-2">
                                <div
                                    className={`h-2 rounded-full transition-all ${isClickable ? 'hover:opacity-80' : ''}`}
                                    style={{
                                        width: `${percentage}%`,
                                        backgroundColor: item.color,
                                    }}
                                />
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

